<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="name">
          <el-input v-model="listQuery.name" placeholder="请输入姓名" clearable @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="listQuery.phone" placeholder="请输入手机号" clearable @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="site_id">
          <el-select v-model="listQuery.site_id" placeholder="请选择门店" clearable @keyup.enter.native="SearchData" @visible-change="setsitelist">
            <el-option
              v-for="item in sitelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status">
          <el-select v-model="listQuery.status" placeholder="请选择状态" clearable @keyup.enter.native="SearchData">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'Coach.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'Coach.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column align="center" prop="name" label="姓名 "> </el-table-column>
      <el-table-column align="center" prop="avatar" label="头像 ">
        <template slot-scope="{ row }">
          <el-avatar :size="40" :src="row.avatar" @error="true">
            <img :src="base_url+'static/image/default_avatar.png'">
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="phone" label="联系电话 "> </el-table-column>
      <el-table-column align="center" prop="gender" label="性别 ">
        <template slot-scope="scope">
          {{ scope.row.gender==1?'男':'女' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="age" label="年龄 ">
        <template slot-scope="scope">
          {{ scope.row.age==0?'未知':scope.row.age }}岁
        </template>
      </el-table-column>
      <el-table-column align="center" prop="certificate_type_name" label="证件类型 "> </el-table-column>
      <el-table-column align="center" prop="certificate_num" label="证件号 "> </el-table-column>
      <el-table-column align="center" prop="school" label="毕业院校 "> </el-table-column>
      <el-table-column align="center" prop="site_name" label="门店"></el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="statusChange($event,scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="price" label="课时单价 ">
        <template slot-scope="scope">
          ￥ {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="is_hot" label="是否推荐 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_hot == 1" type="success">推荐</el-tag>
          <el-tag v-else type="danger">不推荐</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="audit" label="审核状态 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.audit==0" type="info">待审核</el-tag>
          <el-tag v-if="scope.row.audit==1" type="success">已通过</el-tag>
          <el-tag v-if="scope.row.audit==2" type="danger">未通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="280" class-name="action">
        <template slot-scope="scopes">
          <el-button v-if="scopes.row.audit == 0" v-auth="'Coach.audit'" plain icon="el-icon-set-up" type="warning" size="mini" @click="HandleAudit(scopes.row)">审核</el-button>
          <el-button v-if="scopes.row.audit != 0" v-auth="'Coach.update'" plain icon="el-icon-edit" type="primary" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'Coach.delete'" plain icon="el-icon-delete" type="danger" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible" top="8vh" width="900px">
      <el-form v-if="dialogFormVisible" ref="dataForm" :rules="rules" :model="temp" :inline="true" label-position="right" label-width="110px" style="height:65vh;overflow-y:scroll;margin-left:10px;padding-right:30px;">
        <!-- <el-form-item label="用户" prop="user_id" style="margin-bottom:0px;">
          <el-select
            v-model="temp.user_id"
            filterable
            remote
            reserve-keyword
            placeholder="请选择用户"
            :remote-method="getuserlist"
            style="width:300px;"
            @visible-change="setuserlist"
          >
            <el-option v-for="item in userlist" :key="item.id" :label="item.phone+(item.nickname?'【'+item.nickname+'】':'')" :value="item.id"></el-option>
          </el-select>
        </el-form-item><br><br> -->
        <el-form-item label="头像" prop="avatar">
          <FileList v-model="temp.avatar" :item-width="100" :item-height="100" :limit="1" type="image" />
        </el-form-item><br>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="temp.name" placeholder="请输入姓名" style="width:280px" />
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="temp.phone" maxlength="11" placeholder="请输入联系电话" style="width:280px" />
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="temp.gender" style="width:280px">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄" prop="age">
          <el-input-number v-model="temp.age" :min="1" :max="120" :step="1" style="width:280px" />
        </el-form-item>
        <el-form-item label="证件类型" prop="certificate_type">
          <el-select v-model="temp.certificate_type" placeholder="请选择证件类型" style="width:280px">
            <el-option v-for="item in dictionary['certificate_type']" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号" prop="certificate_num">
          <el-input v-model="temp.certificate_num" placeholder="请输入证件号" style="width:280px" />
        </el-form-item>
        <el-form-item label="证件相关证明" prop="certificate_related">
          <FileList v-model="temp.certificate_related" :item-width="100" :item-height="100" :limit="6" type="image" />
        </el-form-item><br>

        <el-form-item label="毕业院校" prop="school">
          <el-input v-model="temp.school" style="width:300px;" placeholder="请输入毕业院校" />
        </el-form-item><br>
        <el-form-item label="学历证明" prop="academic_certificate">
          <FileList v-model="temp.academic_certificate" :item-width="100" :item-height="100" :limit="6" type="image" />
        </el-form-item><br>
        <el-form-item label="门店" prop="site_id">
          <el-select
            v-model="temp.site_id"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请选择门店"
            :remote-method="getsitelist"
            style="width:300px;"
            @visible-change="setsitelist"
          >
            <el-option v-for="item in sitelist" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item><br>

        <el-form-item label="个人标签" prop="be_good_at">
          <el-tag v-for="tag in be_good_at" :key="tag" closable :disable-transitions="false" @close="handleClosebe_good_at(tag)">
            {{ tag }}
          </el-tag>
          <el-input v-if="inputbe_good_atVisible" ref="saveTagInputbe_good_at" v-model="be_good_atValue" maxlength="4" class="input-new-tag" size="small" @keyup.enter.native="handleInputbe_good_atConfirm" @blur="handleInputbe_good_atConfirm">
          </el-input>
          <el-tooltip v-else class="item" effect="dark" content="4字以内，如“左手击球”" placement="right">
            <el-button class="button-new-tag" size="small" @click="showInputbe_good_at">+ 新增标签</el-button>
          </el-tooltip>
        </el-form-item><br>
        <!-- 注意事项 -->
        <el-form-item label="个人荣誉" prop="honor">
          <section v-for="(value, index) in temp.honor" :key="index" style="width: 680px;">
            <section v-if="index == 0">
              <el-row>
                <el-col :span="18">
                  <el-input v-model="temp.honor[index]" maxlength="30" show-word-limit placeholder="请输入个人荣誉" />
                </el-col>
                <el-col v-if="temp.honor.length < 10" :span="4">
                  <el-button type="primary" icon="el-icon-plus" plain style="margin-left:10px;" circle @click="addlastitems(index, '1')" />
                </el-col>
              </el-row>
            </section>
            <section v-if="index > 0">
              <!-- 添加的子项目 -->
              <el-row style="margin-top:10px;">
                <el-col :span="18">
                  <el-input v-model="temp.honor[index]" maxlength="30" show-word-limit placeholder="请输入个人荣誉" />
                </el-col>
                <el-col :span="4">
                  <el-button type="danger" icon="el-icon-delete" plain style="margin-left:10px;" circle @click="rmlastitems(index, '1')" />
                </el-col>
              </el-row>
            </section>
          </section>
        </el-form-item>
        <el-form-item label="简介" prop="desc">
          <el-input v-model="temp.desc" type="textarea" style="width:690px;" :rows="3" placeholder="请输入简介" maxlength="255" show-word-limit />
        </el-form-item>
        <el-form-item label="荣誉证书" prop="qualification_certificate">
          <FileList v-model="temp.qualification_certificate" :item-width="100" :item-height="100" :limit="6" type="image" />
        </el-form-item><br>
        <el-form-item label="课时单价" prop="price">
          <el-input-number v-model="temp.price" :min="0" :step="1" style="width:280px;" placeholder="请输入课时单价" />
        </el-form-item>
        <el-form-item label="是否推荐" prop="is_hot">
          <el-switch v-model="temp.is_hot" active-color="#13ce66" active-text="推荐" active-value="1" inactive-value="0" inactive-text="不推荐"></el-switch>
          <p class="tishi">推荐可在小程序首页进行展示（结合排序编号越小越靠前）</p>
        </el-form-item><br>
        <el-form-item label="排序" prop="order_no">
          <span slot="label">
            排序
            <el-tooltip content="排序越小，小程序展示越靠前" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input-number v-model="temp.order_no" :min="1" :max="99999" />
        </el-form-item><br>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="temp.status" style="width:280px">
            <el-radio :label="0">禁用</el-radio>
            <el-radio :label="1">启用</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
    <!--弹窗审核窗体-->
    <el-dialog title="审核" :visible.sync="dialogAuditVisible" width="80%">

      <el-form v-if="dialogAuditVisible" ref="auditForm" :rules="rulesAudit" :model="auditTemp" label-width="110px">
        <el-form-item label="教练信息">
          <el-descriptions class="margin-top" title="" :column="3" size="medium" border :label-style="{'width':'160px'}" :content-style="{'width':'227px'}">
            <el-descriptions-item label="头像">
              <el-avatar :size="25" :src="auditRow.avatar" @error="true">
                <img :src="base_url+'static/image/default_avatar.png'">
              </el-avatar>
            </el-descriptions-item>
            <el-descriptions-item label="姓名">{{ auditRow.name || '--' }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ auditRow.phone || '--' }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{ auditRow.gender | genderFilter }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{ auditRow.age || '--' }}</el-descriptions-item>
            <el-descriptions-item label="证件类型">{{ auditRow.certificate_type_name || '--' }}</el-descriptions-item>
            <el-descriptions-item label="证件号码">{{ auditRow.certificate_num || '--' }}</el-descriptions-item>
            <el-descriptions-item label="证件相关证明" span="2">
              <el-image
                v-for="(src,index) in auditRow.certificate_related.split(',')"
                :key="index"
                style="width: 60px; height: 40px;margin:3px;"
                fit="contain"
                :src="src"
                :preview-src-list="auditRow.certificate_related.split(',')"
              >
              </el-image>
            </el-descriptions-item>
            <el-descriptions-item label="毕业院校">{{ auditRow.school || '--' }}</el-descriptions-item>
            <el-descriptions-item label="学历证明" span="2">
              <el-image
                v-for="(src,index) in auditRow.academic_certificate.split(',')"
                :key="index"
                style="width: 60px; height: 40px;margin:3px;"
                fit="contain"
                :src="src"
                :preview-src-list="auditRow.certificate_related.split(',')"
              >
              </el-image>
            </el-descriptions-item>
            <el-descriptions-item label="门店" span="3">{{ auditRow.site_name || '--' }}</el-descriptions-item>
            <el-descriptions-item label="个人标签" span="3">
              <el-tag v-for="(tag,index) in auditRow.be_good_at" :key="index" type="info">{{ tag }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="个人荣誉" span="3">
              <el-alert
                v-for="(honor,index) in auditRow.honor"
                :key="index"
                :title="honor"
                type="info"
                :closable="false"
                style="margin:3px;"
              >
              </el-alert>
            </el-descriptions-item>
            <el-descriptions-item label="简介" span="3">{{ auditRow.desc || '--' }}</el-descriptions-item>
            <el-descriptions-item label="荣誉证书" span="2">
              <el-image
                v-for="(src,index) in auditRow.qualification_certificate.split(',')"
                :key="index"
                style="width: 60px; height: 40px;margin:3px;"
                fit="contain"
                :src="src"
                :preview-src-list="auditRow.certificate_related.split(',')"
              >
              </el-image>
            </el-descriptions-item>
            <el-descriptions-item label="课时单价">￥{{ auditRow.price || '0' }}</el-descriptions-item>
          </el-descriptions>

        </el-form-item>
        <el-form-item label="审核状态" prop="audit">
          <el-radio-group v-model="auditTemp.audit">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="auditTemp.audit == 2" label="不通过原因" prop="audit_reason">
          <el-input v-model="auditTemp.audit_reason" type="textarea" rows="5" placeholder="请输入不通过原因" maxlength="255" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAuditVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmAuditData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/coach/coach' // 和数据交互相关写在api 方便复用
import siteapi from '@/api/site/site' // 和数据交互相关写在api 方便复用
import userapi from '@/api/user' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import dict_data from '@/api/system/dict_data'
import FileList from '@/components/attachment/FileList'

export default {
  name: 'Coach',
  filters: {
    genderFilter(val) {
      switch (val) {
        case 1:
          return '男'
        case 2:
          return '女'
        default:
          return '未知'
      }
    }
  },
  components: { Pagination, FileList },
  // 列绑定格式化器
  mixins: [commonList],
  data() {
    var validatebe_good_at = (rule, value, callback) => {
      if (this.temp.be_good_at.length === 0) {
        callback(new Error('请添加个人标签'))
      } else {
        callback()
      }
    }
    // 1：身份证 2：护照 3：回乡证 4:台胞证 5：外国人永久居留身份证 6：港澳台居民居住证
    var validatecertificate_num = (rule, value, callback) => {
      if (!this.temp.certificate_type) {
        callback(new Error('请先选择证件类型'))
      } else {
        if (!value) {
          callback(new Error('请输入有效的证件号码'))
        }
      }
      if (this.temp.certificate_type == 1) {
        const length = 18
        const idCardRegex = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/
        if (!idCardRegex.test(this.temp.certificate_num) || this.temp.certificate_num.length != length) {
          callback(new Error('请输入有效的身份证'))
        } else {
          callback()
        }
      } else if (this.temp.certificate_type == 2) {
        const length = 8
		    const huzhaoreg = /^([a-zA-z]|[0-9]){6,64}$/
        if (!huzhaoreg.test(this.temp.certificate_num) || this.temp.certificate_num.length != length) {
          callback(new Error('请输入有效的护照号码'))
        } else {
          callback()
        }
      } else if (this.temp.certificate_type == 3) {
        const length = 10
        const reg = /^\d{10}$/
        if (!reg.test(this.temp.certificate_num) || this.temp.certificate_num.length != length) {
          callback(new Error('请输入有效的回乡证'))
        } else {
          callback()
        }
      } else if (this.temp.certificate_type == 4) {
        // 台胞证
        const reg = /^[A-Z]{1,2}\d{8}(?:\d{2})?$/
        if (!reg.test(this.temp.certificate_num)) {
          callback(new Error('请输入有效的台胞证'))
        } else {
          callback()
        }
      } else if (this.temp.certificate_type == 5) {
        // 外国人永久居留身份证
        const length = 18
        const reg = /^[A-Za-z0-9]{18}$/
	      if (!reg.test(this.temp.certificate_num) || this.temp.certificate_num.length != length) {
          callback(new Error('请输入有效的外国人永久居留身份证'))
        } else {
          callback()
        }
      } else if (this.temp.certificate_type == 6) {
        // 港澳台居民居住证
        const length = 9
        const reg = /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/
        if (!reg.test(this.temp.certificate_num) || this.temp.certificate_num.length != length) {
          callback(new Error('请输入有效的港澳台居民居住证'))
        } else {
          callback()
        }
      }
    }
    var validateAuditReasonPass = (rule, value, callback) => {
      if (this.auditTemp.audit === 2 && !value) {
        callback(new Error('请输入不通过原因'))
      } else {
        callback()
      }
    }
    return {
      base_url: process.env.VUE_APP_BASE_API,
      api,
      // 校验
      rules: {
        avatar: [{ required: true, message: '请上传头像', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }],
        phone: [{ required: true, message: '请输入联系电话', trigger: ['blur', 'change'] }, { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }],
        age: [
          { required: true, message: '请输入年龄', trigger: ['blur', 'change'] }
        ],
        certificate_type: [{ required: true, message: '请选择证件类型', trigger: ['blur', 'change'] }],
        certificate_num: [{ required: true, validator: validatecertificate_num, trigger: ['blur', 'change'] }],
        certificate_related: [{ required: true, message: '请上传证件相关证明', trigger: ['blur', 'change'] }],
        school: [{ required: true, message: '请输入毕业院校', trigger: ['blur', 'change'] }],
        academic_certificate: [{ required: true, message: '请上传学历证明', trigger: ['blur', 'change'] }],
        site_id: [{ type: 'array', required: true, message: '请选择门店', trigger: ['blur', 'change'] }],
        qualification_certificate: [{ required: true, message: '请上传荣誉证书', trigger: ['blur', 'change'] }],
        be_good_at: [{ required: true, validator: validatebe_good_at, trigger: ['blur', 'change'] }],
        honor: [{ required: true, message: '请输入个人荣誉', trigger: ['blur', 'change'] }],
        desc: [{ required: true, message: '请输入简介', trigger: ['blur', 'change'] }],
        price: [{ required: true, message: '请输入课时单价', trigger: ['blur', 'change'] }]
      },
      rulesAudit: {
        audit: [{ required: true, message: '请选择审核状态', trigger: ['blur', 'change'] }],
        audit_reason: [{ validator: validateAuditReasonPass, trigger: 'blur' }]
      },
      temp: { },
      dialogAuditVisible: false,
      auditRow: {},
      auditTemp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      dictionary: [], // 字典参数
      sitelist: [], // 门店
      inputbe_good_atVisible: false,
      be_good_at: [], // 个人标签数组
      be_good_atValue: '' // 个人标签命名
    }
  },
  watch: {
    'temp.age': {
      handler(val) {
        if (val > 120) {
          this.$message({
            type: 'error',
            message: '年龄不能超过120岁'
          })
        }
        if (val < 1) {
          this.$message({
            type: 'error',
            message: '年龄不能小于1岁'
          })
        }
      }
    }
  },
  created() {
    this.getsitelist('')
    // this.getuserlist('')
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: 'certificate_type,' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    addlastitems(index) {
      this.temp.honor.push('')
    },
    rmlastitems(index) {
      this.temp.honor.splice(index, 1)
      this.$message.success('移除成功')
    },
    HandleAudit(row) {
      this.auditRow = row
      // console.log(this.auditRow.academic_certificate, '---------------')
      // if (this.auditRow.academic_certificate) {
      //   this.auditRow.academic_certificate = this.auditRow.academic_certificate.split(',')
      // } else {
      //   this.auditRow.academic_certificate = []
      // }
      // if (this.auditRow.certificate_related) {
      //   this.auditRow.certificate_related = this.auditRow.certificate_related.split(',')
      // } else {
      //   this.auditRow.certificate_related = []
      // }
      // if (this.auditRow.qualification_certificate) {
      //   this.auditRow.qualification_certificate = this.auditRow.qualification_certificate.split(',')
      // } else {
      //   this.auditRow.qualification_certificate = []
      // }
      this.auditTemp = {
        id: row.id
      }
      this.dialogAuditVisible = true
    },
    ConfirmAuditData() {
      this.$refs['auditForm'].validate(valid => {
        api.Audit(this.auditTemp).then(res => {
          this.$notify({
            title: '成功',
            message: '审核成功',
            type: 'success',
            duration: 2000
          })
          this.loadData()
          this.dialogAuditVisible = false
        })
      })
    },
    getsitelist(str) {
      siteapi.Query({ page: 1, limit: 10, isPaginator: false, name: str, order: 'asc', sort: 'order_no' }).then(response => {
        this.sitelist = response.data
      })
    },
    setsitelist(bool) {
      bool ? '' : this.getsitelist('')
    },
    getuserlist(str) {
      userapi.Query({ page: 1, limit: 10, keyword: str, is_coach: 0, order: 'desc', sort: 'id' }).then(response => {
        this.userlist = response.data.items
      })
    },
    setuserlist(bool) {
      bool ? '' : this.getuserlist('')
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999,
        name: '',
        avatar: '',
        phone: '',
        gender: 1,
        age: 1,
        certificate_num: '',
        school: '',
        be_good_at: [],
        honor: [''],
        desc: '',
        price: 0,
        status: 0,
        site_id: [],
        is_hot: 0
      }
      this.be_good_at = []
    },
    statusChange(val, row) {
      api.ChangeStatus({
        field: 'status',
        value: val,
        id: row.id
      }).then(res => {
        this.$notify({ title: '成功', message: '修改状态成功', type: 'success', duration: 2000 })
      })
    },
    // 显示编辑窗体
    HandleUpdate(row) {
      this.temp = JSON.parse(JSON.stringify(row)) // copy obj
      this.be_good_at = row.be_good_at
      this.dialogStatus = 'update'
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      this.dialogFormVisible = true
    },
    // 提交
    ConfirmData() {
      console.log('我是提交代码')
      // 在验证前先将be_good_at同步到temp对象中
      this.temp.be_good_at = this.be_good_at
      
      this.$refs['dataForm'].validate((valid) => {
        console.log('我是提交代码111111111')
        if (valid) {
          console.log('我是提交代码222222222')
          const obj = { ...this.temp }
          obj.be_good_at = this.be_good_at
          
          if (this.dialogStatus === 'create') {
            // 创建教练
            api.Create(obj).then((response) => {
              this.$notify({
                title: '成功',
                message: response.msg,
                type: 'success',
                duration: 2000
              })
              this.dialogFormVisible = false
              this.loadData()
            })
          } else {
            // 更新教练
            api.Update(obj).then((response) => {
              this.$notify({
                title: '成功',
                message: response.msg,
                type: 'success',
                duration: 2000
              })
              this.dialogFormVisible = false
              this.loadData()
            })
          }
        }
      })
    },
    // 个人标签开始
    handleClosebe_good_at(tag) {
      this.be_good_at.splice(this.be_good_at.indexOf(tag), 1)
    },
    showInputbe_good_at() {
      this.inputbe_good_atVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInputbe_good_at.$refs.input.focus()
      })
    },
    handleInputbe_good_atConfirm() {
      const be_good_atValue = this.be_good_atValue.trim()
      
      if (!be_good_atValue) {
        this.inputbe_good_atVisible = false
        this.be_good_atValue = ''
        return
      }
      
      if (this.be_good_at.length >= 10) {
        this.$message({ message: '个人标签不能超过10个', type: 'warning' })
        this.inputbe_good_atVisible = false
        return
      }
      
      if (this.be_good_at.includes(be_good_atValue)) {
        this.$message({ message: '个人标签已存在', type: 'warning' })
        this.be_good_atValue = ''
        this.inputbe_good_atVisible = false
        return
      }
      
      this.be_good_at.push(be_good_atValue)
      this.inputbe_good_atVisible = false
      this.be_good_atValue = ''
    }
    // 个人标签结束
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 5px;  /* 定义滚动条的宽度 */
}
::-webkit-scrollbar-track {
    background: #ecf5ff; /* 定义轨道的背景颜色 */
}
::-webkit-scrollbar-thumb {
    background: #b3d8ff; /* 定义滑块的背景颜色 */
}
::-webkit-scrollbar-thumb:hover {
    background: #b3d8ff; /* 定义滑块在悬停状态下的背景颜色 */
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.tishi{
 color:  #606266;
}
</style>
